import {Injectable} from '@angular/core';
import {MdDialog, MdSnackBar} from '@angular/material';
import {Field} from '../../interfaces/Field';
import {Observable} from 'rxjs/Observable';
import {FieldEditorDialogComponent} from '../../components/field-editor-dialog/field-editor-dialog.component';

@Injectable()
export class FieldEditorControllerService {

  constructor(public dialog: MdDialog, public snackBar: MdSnackBar) {
  }

  /**
   * Launches the AddItemDialogComponent
   */
  openDialog(fieldGroupId: number, field?: Field): Observable<any> {
    return this.dialog
      .open(FieldEditorDialogComponent, {data: {field: field, fieldGroupId: fieldGroupId}})
      .afterClosed()
      .skipWhile(result => result === 'cancel' || result === undefined)
      .do(result => result);
  }
}




// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/services/field-editor-controller/field-editor-controller.service.ts